import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import HistoryViewer from './HistoryViewer';
import CancelButton from './CancelButton';
import { globalStyles as styles } from './style/gstheme';

class HistoryDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
        };
    }

    render() {

        const { classes, id, graph, options, onExitHistory, open, startTimestamp, projectGraph } = this.props;

        return (
            <Dialog
                data-test="history-dialog"
                maxWidth="lg"
                fullWidth
                classes={{
                    paper: classes.paper,
                    paperWidthMd: classes.largeDialog
                }}
                className={classes.dialog}
                open={open}
                aria-labelledby="history-dialog-title">
                <DialogTitle disableTypography className={classes.mainHeading} id="history-dialog-title">History</DialogTitle>
                <DialogContent style={{ height: 460 }}>
                    <HistoryViewer
                        id={id}
                        otherComponent={true}
                        options={options}
                        projectGraph={projectGraph}
                        startTimestamp={startTimestamp}
                        startDateLabel="Only Changes in This Version"
                        graph={graph}
                        displayTitle={false} />
                </DialogContent>
                <DialogActions className={classes.dialogActions}>
                    <CancelButton onClick={onExitHistory}>Close</CancelButton>
                </DialogActions>
            </Dialog>
        );
    }
}

HistoryDialog.defaultProps = {
    options: [],
    open: false,
    startTimestamp: null
};

HistoryDialog.propTypes = {
    classes: PropTypes.object,
    id: PropTypes.string.isRequired,
    graph: PropTypes.string.isRequired,
    projectGraph: PropTypes.string.isRequired,
    options: PropTypes.array,
    startTimestamp: PropTypes.number,
    onExitHistory: PropTypes.func.isRequired,
    open: PropTypes.bool
};

export default withStyles(styles)(HistoryDialog);